import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import classes from "./UniCellRight.styl";

export interface IRight extends PropsWithChildren {}

const UniCellRight: FC<IRight> = ({ children }): JSX.Element => {
    return (
        <div className={classes["right"]} data-tsid="unicell-right-test-id">
            {children}
        </div>
    );
};

UniCellRight.displayName = "UniCell.Right";

export default UniCellRight;
